import React, { Component, Fragment } from "react";
import "./style.scss";
import {
  NormalButton,
  TableWrapper,
  NormalSelect,
  NormalInput,
  NormalCheckbox,
  NormalRadio,
  NormalDate,
  NormalModal,
} from "component/common";
import {
  getCommonApi,
  updateForm,
  commonCreateApi,
  commonDeleteApi,
  commonPatchApi,
} from "redux/actions/common";
import shareIcon from "assets/images/shareicon.png";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import { PDFViewer, PDFDownloadLink, BlobProvider } from "@react-pdf/renderer";

import {
  PDFDownloadLink,
  Page,
  Text,
  View,
  Document,
  StyleSheet,
} from "@react-pdf/renderer";
import Invoice from "component/Admin/Report/Account/Invoice";
import { withTranslation } from "react-i18next";
import { dateFormat } from "service/helperFunctions";
import { Button, Form, FormGroup, Label, Input, FormText } from "reactstrap";
import moment from "moment/moment";
import closeIcon from "assets/images/close.png";
import { CredentialConfirmation } from "component/Admin/Cart/credentialConfirmation";
import { Toast } from "service/toast";
import CustomerHeader from "component/Admin/Report/Account/CustomerHeader";
import {
  AccountDetailInfo,
  AccountMainInfo,
  PrepaidDetailInfo,
  PrepaidInfo,
  ProductDetailMain,
  ProductMainInfo,
  ProductPurchaseTopHeaderAndData,
} from "component/Admin/Report/Account/TreatmentAccount";
import { CreditMainInfo } from "component/Admin/Report/Account/TreatmentAccount/CreditReport";
import {
  ManualInvoiceMainInfo,
  ManualInvoiceSecondaryInfo,
} from "component/Admin/Report/Account/Quantum/ManualInvoice";
import InvoiceItemsTable from "component/Admin/Report/Account/InvoiceItemsTable";
import CustomerFooter from "component/Admin/Report/Account/CustomerFooter";
import { ShareModal } from "component/Admin/Cart/sharePackage";

const styles = StyleSheet.create({
  page: {
    backgroundColor: "#E4E4E4",
  },
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
});

const MyDoc = ({ accountHeader, Flag, TableList }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <CustomerHeader accountHeader={accountHeader} />
      {Flag == 1 ? (
        <AccountMainInfo accountHeader={accountHeader} />
      ) : Flag == 2 ? (
        <CreditMainInfo accountHeader={accountHeader} />
      ) : Flag == 3 ? (
        <PrepaidInfo accountHeader={accountHeader} />
      ) : Flag == 5 ? (
        <ProductMainInfo accountHeader={accountHeader} />
      ) : Flag == 6 ? (
        <ProductDetailMain accountHeader={accountHeader} />
      ) : Flag == 4 ? (
        <PrepaidDetailInfo accountHeader={accountHeader} />
      ) : Flag == 9 ? (
        <ProductPurchaseTopHeaderAndData
          accountHeader={accountHeader}
          Flag={Flag}
        />
      ) : Flag == 7 ? (
        <ManualInvoiceMainInfo
          accountHeader={TableList.manualinvoice}
          Flag={Flag}
        />
      ) : Flag == 8 ? (
        <ManualInvoiceMainInfo
          accountHeader={TableList.workordinvoice}
          Flag={Flag}
        />
      ) : (
        <AccountDetailInfo accountHeader={accountHeader} />
      )}

      <InvoiceItemsTable TableList={TableList} Flag={Flag} />

      {Flag == 7 && (
        <Fragment>
          <ManualInvoiceSecondaryInfo
            accountHeader={TableList.manualinvdtl}
          ></ManualInvoiceSecondaryInfo>
          <View style={styles.footerContainer}>
            <Text>{TableList.manualinvoice["footer"]}</Text>
          </View>
        </Fragment>
      )}

      {Flag == 8 && (
        <Fragment>
          <ManualInvoiceSecondaryInfo
            accountHeader={TableList.workordinvdtl}
          ></ManualInvoiceSecondaryInfo>
          <View style={styles.footerContainer}>
            <Text>{TableList.workordinvoice["footer"]}</Text>
          </View>
        </Fragment>
      )}
      <CustomerFooter />
    </Page>
  </Document>
);

export class TreatmentAccountClass extends Component {
  state = {
    activeTab: "",
    isOpenTreatmentDone: false,
    isActiveTab: "detail",
    headerDetails: [
      { label: "", sortKey: false, width: "72px" },
      { label: "", sortKey: false, width: "40px" },
      {
        label: "Date",
        sortKey: false,
        width: "50px",
        singleClickFunc: () => this.handleSort(`sa_date`),
        // divClass: "justify-content-end text-right",
      },

      { label: "Description", sortKey: false, width: "155px" },
      {
        label: "Credit Balance",
        sortKey: false,
        width: "72px",
        divClass: "justify-content-end text-right",
      },
      {
        label: "Payment",
        sortKey: false,
        width: "70px",
        divClass: "justify-content-end text-right",
      },

      {
        label: "Outstanding",
        sortKey: false,
        width: "72px",
        divClass: "justify-content-end text-right",
      },
      {
        label: "QTY",
        sortKey: false,
        width: "72px",
        divClass: "justify-content-end text-right",
      },
      {
        label: "Balance QTY",
        sortKey: false,
        width: "72px",
        divClass: "justify-content-end text-right",
      },
      { label: "Transaction", width: "52px" },
      { label: "Treatment No", sortKey: false, width: "75px" },
    ],
    detailHeader: [
      {
        label: "Date",
        sortKey: true,
        width: "80px",
        singleClickFunc: () => this.handleDetailSort("sa_date"),
        // divClass: "justify-content-end text-right",
      },
      { label: "Transaction #", width: "75px" },
      { label: "Description", sortKey: false, width: "145px" },
      { label: "Type", width: "52px" },
      {
        label: "Payment",
        sortKey: false,
        width: "70px",
        divClass: "justify-content-end text-right",
      },
      {
        label: "Credit Balance",
        sortKey: false,
        width: "72px",
        divClass: "justify-content-end text-right",
      },
      {
        label: "Outstanding",
        sortKey: false,
        width: "72px",
        divClass: "justify-content-end text-right",
      },
    ],
    accountList: [],
    printaccountList: [],
    DetailList: [],
    yearList: [
      {
        label: "Default",
        value: "Default",
      },
      {
        label: "Expiry",
        value: "Expiry",
      },
    ],
    year: new Date().getFullYear(),
    accountHeader: {},
    isPrintPdfClick: false,
    orderBy: "desc",
    orderByDetail: "desc",
    show: true,
    page: 1,
    meta: {},
    isLoading: false,
    expiry_date: "",
    isOpenTerminatePrepaid: false,
    dateSelected: "",
    isCustomerLoginConfirmation: false,
    user: "",
    pass: "",
    isSharePopup: false,
    selectedPackage: "",
  };

  componentDidMount() {
    this.setState({
      isLoading: true,
    });
    this.getFilter();
    this.getAccountData({});
    this.getPrintData({});
  }

  handleSort = async () => {
    await this.setState({
      orderBy: this.state.orderBy == "asc" ? "desc" : "asc",
    });

    this.getAccountData({});
    this.getPrintData({});
  };

  handleDetailSort = async (sortkey) => {
    let { DetailList, orderByDetail } = this.state;
    await this.setState({
      orderByDetail: this.state.orderByDetail == "asc" ? "desc" : "asc",
    });

    if (orderByDetail === "asc") {
      DetailList.sort((a, b) =>
        a[sortkey] > b[sortkey] ? 1 : b[sortkey] > a[sortkey] ? -1 : 0
      );
    } else {
      DetailList.sort((a, b) =>
        a[sortkey] < b[sortkey] ? 1 : b[sortkey] < a[sortkey] ? -1 : 0
      );
    }
    this.setState({
      DetailList,
    });
  };

  getFilter = () => {
    this.props.getCommonApi("treatmentdone/Year/").then((key) => {
      let { status, data } = key;
      let { yearList } = this.state;
      for (let value of data) {
        yearList.push({ value: value, label: value });
      }
      this.setState({ yearList });
    });
  };

  // getPrintData
  getPrintData = (data) => {
    this.setState({
      isLoading: true,
    });
    let { year, accountHeader } = this.state;
    let { page = 1, limit = 12, search = "" } = data;
    this.props
      .getCommonApi(
        `treatmentacclist/?cust_id=${this.props.id}&year=${year}&value=${
          this.state.orderBy
        }&show_type=${Number(this.state.show)}&key=sa_date`
      )
      .then((key) => {
        let { data } = key;
        if (data) {
          console.log("printData" + JSON.stringify(data));
          this.setState({
            printaccountList: key?.data?.dataList,
          });
        }
      });
  };

  getAccountData = (data) => {
    this.setState({
      isLoading: true,
    });
    let { year, accountHeader } = this.state;
    let { page = 1, limit = 12, search = "" } = data;
    this.props
      .getCommonApi(
        `treatmentacclist/?cust_id=${this.props.id}&year=${year}&value=${
          this.state.orderBy
        }&show_type=${Number(
          this.state.show
        )}&page=${page}&limit=${limit}&key=sa_date`
      )
      .then((key) => {
        //console.log(key.data, "treatment account table list");
        let { data, header_data } = key;
        //let { accountList } = this.state;
        //accountList = data;
        //accountHeader = header_data;
        //this.setState({ accountList, accountHeader, });
        if (data) {
          this.setState({
            accountList: key?.data?.dataList,
            meta: key?.data?.meta?.pagination,
          });
          //console.log(this.state.accountList, "treatment account table list");
        }

        if (header_data) {
          this.setState({
            accountHeader: key?.header_data,
          });
        }

        this.setState({
          isLoading: false,
        });
      });
  };

  toggle = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
      });
    }
  };

  handleChange = async ({ target: { value, name } }) => {
    let { year } = this.state;
    year = value;
    await this.setState({
      year,
    });
    this.getAccountData({});
    this.getPrintData({});
  };

  handleOpenDetail = async (data) => {
    let { activeTab } = this.state;
    activeTab = "detail";

    await this.setState({
      activeTab,
    });
    this.getDetailList(data.id);
  };

  getDetailList = (id) => {
    this.props.getCommonApi(`treatmentacclist/${id}`).then((key) => {
      let { data, header_data } = key;
      let { DetailList, accountHeader } = this.state;
      DetailList = data;
      accountHeader = header_data;
      console.log("data" + JSON.stringify(header_data));
      this.setState({
        DetailList,
        accountHeader,
        dateSelected:
          accountHeader?.expiry_date && new Date(accountHeader?.expiry_date),
      });
    });
  };

  handlemainPagination = (page) => {
    this.getAccountData(page);
  };

  handleBack = () => {
    let { activeTab } = this.state;
    activeTab = "";
    this.setState({
      activeTab,
      DetailList: [],
    });
    this.getAccountData({});
    this.getPrintData({});
  };
  handlePrintPdfFormat = (url) => {
    this.setState({
      isPrintPdfClick: false,
    });
    var a = document.createElement("a");
    a.setAttribute("download", `${new Date()}.pdf`);
    a.setAttribute("href", url);
    a.click();
    window.open(url);
  };
  handleSelectionChange = async (type) => {
    let { show } = this.state;
    show = type;
    await this.setState({
      show,
    });

    this.getAccountData({});
    this.getPrintData({});
  };

  // handleTerminatePrepaid
  handleTerminatePrepaid = () => {
    this.setState({
      isOpenTerminatePrepaid: !this.state.isOpenTerminatePrepaid,
    });
  };

  // handleChangeExpiryDate
  handleChangeExpiryDate = ({ target: { value } }) => {
    this.setState({
      dateSelected: value,
    });
  };

  // updateChangeExpireDate
  changeExpiryDateSubmit = (user, pass) => {
    let changeDateMoment = moment(this.state.dateSelected).format("YYYY-MM-DD");
    let data = {
      expiry_date: changeDateMoment,
      treatment_parentcode: this.state.accountHeader?.treatparent_code,
    };
    if (user) data.username = user ?? "";
    if (pass) data.password = pass ?? "";
    this.props
      .commonCreateApi(`treatmentacclist/service_expirydatechange/`, data)
      .then((getStatus) => {
        let { status, message } = getStatus;
        if (status === 200) {
          Toast({
            type: "success",
            message: message,
          });
          this.setState({
            accountHeader: {
              ...this.state.accountHeader,
              expiry_date: this.state.dateSelected,
            },
          });
          this.setState({
            isOpenTerminatePrepaid: false,
            isCustomerLoginConfirmation: false,
          });
        } else {
          Toast({
            type: "error",
            message: message,
          });
        }

        // this.handleTerminatePrepaid();
      });
  };

  // handleCustLoginConfirmationDialog
  handleCustLoginConfirmationDialog = () => {
    this.setState({
      isCustomerLoginConfirmation: false,
    });
  };

  // handleCustLoginConfirmationDialog
  handleLoginAuthModalVisible = () => {
    this.setState({
      isCustomerLoginConfirmation: true,
    });
  };

  handleShareDialog = () => {
    this.setState({
      isSharePopup: false,
    });
  };

  handleShareIcon = (item) => {
    let sharePackage = {
      id: item?.itemcart_id,
      item_desc: item?.description,
      cust_noid: Number(this.props.id),
      shareId: item?.id,
    };
    this.setState({
      selectedPackage: sharePackage,
      isSharePopup: true,
    });
  };

  render() {
    let {
      accountHeader = {},
      headerDetails,
      accountList,
      yearList,
      year,
      activeTab,
      detailHeader,
      DetailList,
      isPrintPdfClick,
      invoice,
      show,
      meta,
      isLoading,
      printaccountList,
      isSharePopup,
      selectedPackage,
    } = this.state;
    let {
      balance,
      treatment_count,
      outstanding,
      credit_balance,
      outstanding_balance,
      treatparent_code,
      sa_transacno_ref,
      expiry_date,
    } = accountHeader;
    let { t } = this.props;
    return (
      <div className="treatment-account row">
        {activeTab !== "detail" ? (
          <div className="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-3 mt-3 mb-4">
            <div className="row m-0">
              <div className="col-12 mb-2">
                <FormGroup check>
                  <Label check>
                    <Input
                      checked={show ? true : false}
                      onChange={() => this.handleSelectionChange(true)}
                      type="radio"
                      name="radio1"
                    />{" "}
                    {t("Show Available Package Only")}
                  </Label>
                </FormGroup>
              </div>
              <div className="col-12">
                <FormGroup check>
                  <Label check>
                    <Input
                      checked={!show ? true : false}
                      onChange={() => this.handleSelectionChange(false)}
                      type="radio"
                      name="radio1"
                    />{" "}
                    {t("Show All")}
                  </Label>
                </FormGroup>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
        <div
          className={`${
            activeTab !== "detail"
              ? "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4"
              : "col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4"
          } mt-3 mb-4`}
        >
          {activeTab !== "detail" ? (
            <div className="row">
              <div className="col-6 col-sm-7 col-md-7 col-lg-7 col-xl-5 mb-2">
                {t("Treatment List")}
              </div>
              <div className="col-6 col-sm-5 col-md-5 col-lg-5 col-xl-5 mb-2">
                <NormalSelect
                  options={yearList}
                  value={year}
                  name="year"
                  onChange={this.handleChange}
                  className="customer-name py-1"
                />
              </div>
              <div className="col-7 col-sm-7 col-md-7 col-lg-7 col-xl-5">
                {t("Total Treatment Count")}
              </div>
              <div className="col-5 col-sm-5 col-md-5 col-lg-5 col-xl-5 ">
                {treatment_count}
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-6 mb-2">{t("Transaction #")}</div>
              <div className="col-6 mb-2 ">{sa_transacno_ref}</div>

              <div className="col-6">{t("Treatment No")}</div>
              <div className="col-6">{treatparent_code}</div>
            </div>
          )}
        </div>
        <div
          className={`${
            activeTab !== "detail"
              ? "col-12 col-sm-8 col-md-8 col-lg-8 col-xl-4"
              : "col-12 col-sm-8 col-md-8 col-lg-8 col-xl-4"
          } mt-3 mb-4`}
        >
          <div className="row m-0 p-0">
            <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-2">
              {t("Credit Balance")}
            </div>
            <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 mb-2">
              $ {activeTab !== "detail" ? balance : credit_balance}
            </div>

            <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              {t("Outstanding Balance")}
            </div>
            <div className="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
              $ {activeTab !== "detail" ? outstanding : outstanding_balance}
            </div>
            {/* {activeTab && (
              <div className="col-6">
                <p>Expiry:{expiry_date}</p>
              </div>
            )}
            <div className="col-6 mb-2">
              {activeTab && (
                <NormalButton
                  buttonClass={"back mr-3"}
                  mainbg={true}
                  className="col-12 fs-15 "
                  label="Change Expiry Date"
                  onClick={() => this.handleTerminatePrepaid()}
                />
              )}
              <NormalModal
                className={"transaction-done-modal"}
                style={{ minWidth: "30%" }}
                isHeight={true}
                modal={this.state.isOpenTerminatePrepaid}
                handleModal={this.handleTerminatePrepaid}
              >
                <div className="d-flex justify-content-between">
                  <div className="heading">
                    <h5> Extend Expiry Date </h5>
                  </div>

                  <div>
                    <img
                      onClick={() => this.handleTerminatePrepaid()}
                      className="close"
                      src={closeIcon}
                      alt=""
                    />
                  </div>
                </div>
                <div>
                  <div className="content">
                    <div className="d-flex mt-4">
                      <div className="col-6">
                        <NormalDate
                          value={this.state.dateSelected}
                          name="expiry_date"
                          type="date"
                          minDate={new Date()}
                          onChange={this.handleChangeExpiryDate}
                        />
                      </div>
                      <div className="col-6">
                        <NormalButton
                          applybg={true}
                          label="Update"
                          onClick={() => this.changeExpiryDate()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </NormalModal>
            </div> */}
          </div>
        </div>

        <div
          className={`${activeTab !== "detail" ? "col-4" : "col-4"} mt-3 mb-4`}
        >
          <div className="row">
            {activeTab && (
              <div className="col-12 datePickerCenterAlign">
                {/* <p>Expiry : &nbsp;{expiry_date}</p> */}
                {console.log("expiry_date" + JSON.stringify(expiry_date))}
                <p>
                  Expiry : &nbsp;
                  {expiry_date ? moment(expiry_date).format("DD/MM/YYYY") : ""}
                </p>
              </div>
            )}
            <div className="col-12 mb-2 datePickerCenterAlign">
              {activeTab && this.props.tokenDetails.service_expirydate && ( 
              <NormalButton
                buttonClass={"back mr-3"}
                mainbg={true}
                className="col-12 fs-15 "
                label="Change Expiry Date"
                onClick={() => this.handleTerminatePrepaid()}
              />
              )} 
              <NormalModal
                className={"transaction-expiry-modal"}
                style={{ minWidth: "35%", maxHeight: "15%" }}
                isHeight={true}
                modal={this.state.isOpenTerminatePrepaid}
                handleModal={this.handleTerminatePrepaid}
              >
                <div className="d-flex justify-content-between">
                  <div className="heading">
                    <h5> Extend Expiry Date </h5>
                  </div>

                  <div>
                    <img
                      onClick={() => this.handleTerminatePrepaid()}
                      className="close"
                      src={closeIcon}
                      alt=""
                    />
                  </div>
                </div>
                <div>
                  <div className="content p-1">
                    <div className="d-flex mt-4">
                      <div className="col-6">
                        <NormalDate
                          value={this.state.dateSelected}
                          name="expiry_date"
                          type="date"
                          minDate={new Date()}
                          onChange={this.handleChangeExpiryDate}
                          // dateFormat={"DD/MM/YYYY"}
                        />
                      </div>

                      <div className="col-3">
                        <NormalButton
                          applybg={true}
                          label="Update"
                          onClick={() => this.handleLoginAuthModalVisible()}
                        />
                      </div>
                      <div className="col-3">
                        <NormalButton
                          resetbg={true}
                          label="cancel"
                          onClick={() => this.handleTerminatePrepaid()}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </NormalModal>
            </div>
          </div>
        </div>

        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 overflowTable">
          <div className="table">
            {activeTab !== "detail" ? (
              <TableWrapper
                headerDetails={headerDetails}
                queryHandler={this.handlemainPagination}
                pageMeta={meta}
              >
                {isLoading ? (
                  <tr>
                    <td colSpan="12">
                      <div class="d-flex mt-5 align-items-center justify-content-center">
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ) : accountList && accountList.length > 0 ? (
                  accountList.map((item, index) => {
                    return (
                      <tr key={index}>
                          <td>
                          <div className="d-flex align-items-center justify-content-center">
                            <NormalButton
                              buttonClass={"view mr-3"}
                              mainbg={true}
                              className="col-12 fs-15 "
                              label="view"
                              onClick={() => this.handleOpenDetail(item)}
                            />
                          </div>
                        </td>
                        <td>
                          <div
                            className={`d-flex align-items-center justify-content-center`}
                          >
                            <img
                              src={shareIcon}
                              className="share-icon"
                              onClick={() => this.handleShareIcon(item)}
                            />
                          </div>
                        </td>
                        <td>
                          <div className="text-left">{item.sa_date}</div>
                        </td>

                        <td>
                          <div className="text-left">{item.description}</div>
                        </td>
                        <td>
                          <div className="text-right">{"$" + item.balance}</div>
                        </td>
                        <td>
                          <div className="text-right">{"$" + item.payment}</div>
                        </td>

                        <td>
                          <div className="text-right">
                            {"$" + item.outstanding}
                          </div>
                        </td>
                        <td>
                          <div className="text-right">{item.qty}</div>
                        </td>
                        <td>
                          <div className="text-right">{item.balance_qty}</div>
                        </td>

                        <td>
                          <div className="text-left">{item.transaction}</div>
                        </td>
                        <td>
                          <div className="text-left">
                            {item.treatment_parentcode}
                          </div>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="12">
                      <div className="d-flex align-items-center justify-content-center">
                        {t("No data available")}
                      </div>
                    </td>
                  </tr>
                )}
              </TableWrapper>
            ) : (
              <TableWrapper
                headerDetails={detailHeader}
                queryHandler={this.handlePagination}
              >
                {DetailList && DetailList.length > 0
                  ? DetailList.map((item, index) => {
                      return (
                        <tr key={index}>
                          <td>
                            <div className="text-left">{item.sa_date}</div>
                          </td>
                          <td>
                            <div className="text-left">{item.transaction}</div>
                          </td>
                          <td>
                            <div className="text-left">{item.description}</div>
                          </td>
                          <td>
                            <div className="text-left">{item.type}</div>
                          </td>
                          <td>
                            <div className="text-right">
                              {"$" + item.amount}
                            </div>
                          </td>
                          <td>
                            <div className="text-right">
                              {"$" + item.balance}
                            </div>
                          </td>
                          <td>
                            <div className="text-right">
                              {"$" + item.outstanding}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  : null}
              </TableWrapper>
            )}
          </div>
        </div>
        <div className="col-12 justify-center d-flex">
          {activeTab === "detail" ? (
            <NormalButton
              buttonClass={"back mr-3"}
              mainbg={true}
              className="col-12 fs-15 "
              label="Back"
              onClick={() => this.handleBack()}
            />
          ) : (
            ""
          )}
          {(activeTab !== "detail" &&
            printaccountList &&
            printaccountList.length > 0) ||
          (activeTab == "detail" && DetailList && DetailList.length > 0) ? (
            <NormalButton
              buttonClass={"print"}
              className="col-12 fs-15 "
              label="Print"
              onClick={() => {
                this.setState({ isPrintPdfClick: true });
              }}
            />
          ) : null}
        </div>

        {isPrintPdfClick ? (
          <PDFDownloadLink
            document={
              // <MyDoc
              //   accountHeader={accountHeader}
              //   TableList={activeTab !== "detail" ? accountList : DetailList}
              //   Flag={activeTab !== "detail" ? 1 : 2}
              // />
              <Invoice
                TableList={
                  activeTab !== "detail" ? printaccountList : DetailList
                }
                accountHeader={accountHeader}
                Flag={activeTab !== "detail" ? 1 : 2}
                landscape={activeTab !== "detail" ? true : false}
              />
            }
          >
            {({ blob, url, loading, error }) =>
              !loading && url ? this.handlePrintPdfFormat(url) : null
            }
          </PDFDownloadLink>
        ) : null}

        <NormalModal
          className={"d-flex justify-content-center"}
          style={{ minWidth: "20%" }}
          modal={this.state.isCustomerLoginConfirmation}
          handleModal={() => {}}
        >
          <img
            onClick={this.handleCustLoginConfirmationDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <CredentialConfirmation
            handleLoginSubmit={(user, pass) =>
              this.changeExpiryDateSubmit(user, pass)
            }
          />
        </NormalModal>
        <NormalModal
          className={"edit-cart-modal"}
          style={{ minWidth: "75%" }}
          modal={isSharePopup}
          handleModal={this.handleShareDialog}
        >
          <img
            onClick={this.handleShareDialog}
            className="close cursor-pointer"
            src={closeIcon}
            alt=""
          />
          <ShareModal
            selectedPackage={selectedPackage}
            handleClose={this.handleShareDialog}
          />
        </NormalModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  tokenDetails: state.authStore.tokenDetails,
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      getCommonApi,
      updateForm,
      commonCreateApi,
      commonPatchApi,
      commonDeleteApi,
    },
    dispatch
  );
};

export const TreatmentAccount = withTranslation()(
  connect(mapStateToProps, mapDispatchToProps)(TreatmentAccountClass)
);
